// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-262e8f95] .p-radiobutton .p-radiobutton-box.p-highlight{background:#fff!important}[data-v-262e8f95] .p-radiobutton-box.p-highlight .p-radiobutton-icon{background:var(--main)!important}", ""]);
// Exports
module.exports = exports;
